'use strict';

const Cart = require('./Cart.js');
const { handleGuestCheckout } = require('../../guest_checkout/frontend');

const renderFormItems = items =>
  items.reduce((html, { index, dealUuid, uuid, quantity }) => {
    const itemHtml = `
      <input type="hidden" name="items[${index}][deal_uuid]" value="${dealUuid}">
      <input type="hidden" name="items[${index}][option_uuid]" value="${uuid}">
      <input type="hidden" name="items[${index}][quantity]" value="${quantity}">
    `;
    return html + itemHtml;
  }, '');

class CartForm {
  constructor(cartData) {
    this.data = cartData;
    this.formId = this.data.formId;
    this.form = document.getElementById(this.formId);
    this.formItems = document.getElementById(
      this.data.cartFormItemsId || 'cart-form-items'
    );
    this.cart = new Cart();
    this.ready = false;
    if (this.data.items) {
      this.data.items.forEach(item => this.addItem(item));
    }
    this.render();
    this.registerEvents();
    return this;
  }

  registerEvents() {
    window.DealEventPipe.on(
      'cartFormAddItem',
      this.onCartFormAddItem.bind(this)
    );
    window.DealEventPipe.on(
      'cartFormInitialize',
      this.onCartFormInitialize.bind(this)
    );
    window.DealEventPipe.on(
      'cartFormRemoveItem',
      this.onCartFormRemoveItem.bind(this)
    );
    window.DealEventPipe.on('cartFormSubmit', this.onCartFormSubmit.bind(this));
  }

  render() {
    this.formItems.innerHTML = renderFormItems(this.getItems());
    this.ready = true;
  }
  addItem(item) {
    this.cart.addItem(item);
    this.render();
  }
  removeItem(item) {
    this.cart.removeItem(item);
    this.render();
  }
  getItems() {
    return this.cart.getItems();
  }
  cleanCart() {
    this.cart.clean();
    this.render();
  }
  onCartFormAddItem(item, done) {
    this.addItem(item);
    if (done) {
      done();
    }
  }
  onCartFormInitialize(item) {
    this.cleanCart();
    if (item) {
      this.addItem(item);
    }
    this.render();
  }
  onCartFormRemoveItem(item, done) {
    this.removeItem(item);
    if (done) {
      done();
    }
  }
  onCartFormSubmit(ev) {
    this.submit(ev);
  }
  hasItems() {
    return !!this.cart.getItems().length;
  }
  submit(ev) {
    if (this.ready && this.hasItems()) {
      handleGuestCheckout(
        {
          ev,
          isCart: true,
          payloadData: this.data,
        },
        () => {
          this.form.submit();
        }
      );
    }

    return true;
  }
}

module.exports = CartForm;
